import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

// shared modules
import { SharedModule } from '../shared/shared.module';

// containers
import { RegisterSectionComponent } from './containers/register-section/register-section.component';
import { ValidateEmailSectionComponent } from './containers/validate-email-section/validate-email-section.component';
import { SetPasswordSectionComponent } from './containers/set-password-section/set-password-section.component';
import { AccountDetailsSectionComponent } from './containers/account-details-section/account-details-section.component';

// components
import { RegisterComponent } from './components/register/register.component';
import { ValidateEmailComponent } from './components/validate-email/validate-email.component';
import { AccountDetailsComponent } from './components/account-details/account-details.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgSelectModule
  ],
  declarations: [
    RegisterSectionComponent,
    RegisterComponent,
    ValidateEmailSectionComponent,
    ValidateEmailComponent,
    SetPasswordSectionComponent,
    AccountDetailsSectionComponent,
    AccountDetailsComponent
  ]
})
export class RegisterSectionModule { }
